/* Self-contained hero crossfade, mobile HOLY sizing and copy fitting. */
(function () {
  function initDiaporama(root) {
    if (root.dataset.nwInitialized === 'true') return;
    root.dataset.nwInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nw-slide]'));
    var copies = Array.prototype.slice.call(root.querySelectorAll('[data-nw-copy]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nw-dot]'));
    var prevBtn = root.querySelector('[data-nw-prev]');
    var nextBtn = root.querySelector('[data-nw-next]');
    var stage = root.querySelector('.nw-diaporama');
    var section = root.closest('[id^="shopify-section"]');
    var total = slides.length;
    if (total === 0) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) autoplay = false;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var timeoutId = null;
    var startedAt = null;
    var remaining = speed;
    var paused = false;
    var touchStartX = null;
    var touchStartY = null;
    var layoutFrame = null;

    function dotFill(index) {
      return dots[index] ? dots[index].querySelector('[data-nw-dot-fill]') : null;
    }

    function clearFills() {
      dots.forEach(function (dot) {
        var fill = dot.querySelector('[data-nw-dot-fill]');
        if (!fill) return;
        fill.style.animation = 'none';
        fill.style.transform = 'scaleX(0)';
      });
    }

    function startFill(duration) {
      clearFills();
      var fill = dotFill(current);
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = 'nw-diaporama-fill ' + duration + 'ms linear forwards';
      fill.style.animationPlayState = 'running';
    }

    function resetReveal(copy) {
      if (!copy) return;
      copy.querySelectorAll('animate-element').forEach(function (node) {
        if (typeof node.reset === 'function') node.reset();
      });
    }

    function refreshReveal(copy) {
      if (!copy) return;
      copy.querySelectorAll('animate-element').forEach(function (node) {
        if (typeof node.refresh === 'function') node.refresh();
      });
    }

    function goTo(index) {
      index = (index + total) % total;
      if (index === current) return;
      var previous = slides[current];
      var previousCopy = copies[current];
      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden', 'true');
      if (previousCopy) {
        previousCopy.classList.remove('is-active');
        previousCopy.setAttribute('aria-hidden', 'true');
      }
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].removeAttribute('aria-current');
      }
      current = index;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (copies[current]) {
        copies[current].classList.add('is-active');
        copies[current].setAttribute('aria-hidden', 'false');
      }
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-current', 'true');
      }
      resetReveal(previousCopy);
      refreshReveal(copies[current]);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function clearTimer() {
      if (!timeoutId) return;
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    function armTimer(duration) {
      clearTimer();
      startedAt = Date.now();
      remaining = duration;
      timeoutId = setTimeout(function () {
        next();
        play();
      }, duration);
    }

    function play() {
      clearTimer();
      paused = false;
      if (total > 1 && autoplay) {
        armTimer(speed);
        startFill(speed);
      } else {
        clearFills();
      }
    }

    function pause() {
      if (!autoplay || total < 2 || paused) return;
      paused = true;
      remaining -= Date.now() - startedAt;
      if (remaining < 0) remaining = 0;
      clearTimer();
      var fill = dotFill(current);
      if (fill) fill.style.animationPlayState = 'paused';
    }

    function resume() {
      if (!autoplay || total < 2 || !paused) return;
      paused = false;
      armTimer(remaining || speed);
      var fill = dotFill(current);
      if (fill) fill.style.animationPlayState = 'running';
    }

    function syncHeaderClearance() {
      if (!section) return;
      var header = document.querySelector('.header');
      if (!header) return;
      var headerStyle = window.getComputedStyle(header);
      var clearance = 0;
      if (headerStyle.position === 'absolute' || headerStyle.position === 'fixed') {
        var headerRect = header.getBoundingClientRect();
        var rootRect = root.getBoundingClientRect();
        clearance = Math.max(0, headerRect.bottom - rootRect.top);
      }
      section.style.setProperty('--nw-header-clearance', Math.round(clearance) + 'px');
    }

    function syncHolyHeight() {
      if (!section || !stage) return;
      if (window.innerWidth > 767 || root.getAttribute('data-mobile-height') !== 'holy') {
        section.style.removeProperty('--nw-holy-mobile-height');
        return;
      }
      var aspectRatio = parseFloat(root.getAttribute('data-mobile-aspect-ratio')) || 0.5;
      var ratioHeight = stage.clientWidth / aspectRatio;
      var viewportHeight = window.visualViewport && window.visualViewport.height
        ? window.visualViewport.height
        : window.innerHeight;
      var holyHeight = Math.min(ratioHeight, 747, viewportHeight + 70);
      section.style.setProperty('--nw-holy-mobile-height', Math.max(1, Math.round(holyHeight)) + 'px');
    }

    function syncMobileLayout() {
      syncHeaderClearance();
      syncHolyHeight();
    }

    function scheduleMobileLayout() {
      if (layoutFrame) window.cancelAnimationFrame(layoutFrame);
      layoutFrame = window.requestAnimationFrame(function () {
        layoutFrame = null;
        syncMobileLayout();
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { goTo(index); play(); });
    });

    if (stage) {
      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (touchStartX === null || touchStartY === null || event.changedTouches.length !== 1) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        if (deltaX < 0) next();
        else prev();
        play();
      }, { passive: true });
      stage.addEventListener('touchcancel', function () {
        touchStartX = null;
        touchStartY = null;
      }, { passive: true });
    }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) resume();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prev();
        play();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        next();
        play();
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else resume();
    });

    root.querySelectorAll('[data-nw-cta]').forEach(function (cta) {
      cta.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'select_promotion',
          ecommerce: {
            creative_name: cta.getAttribute('data-cta-label') || '',
            creative_slot: 'hero_diaporama_button_' + (cta.getAttribute('data-cta-position') || ''),
            promotion_id: cta.getAttribute('data-cta-id') || '',
            promotion_name: cta.getAttribute('data-cta-slide-title') || cta.getAttribute('data-cta-label') || '',
            location_id: 'hero_diaporama',
            items: []
          },
          utm_campaign: cta.getAttribute('data-cta-utm-campaign') || '',
          utm_content: cta.getAttribute('data-cta-utm-content') || ''
        });
      });
    });

    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', function (event) {
        var index = slides.findIndex(function (slide) { return slide === event.target; });
        if (index > -1) goTo(index);
        clearTimer();
        clearFills();
        scheduleMobileLayout();
      });
      root.addEventListener('shopify:block:deselect', play);
    }

    root.setAttribute('tabindex', '0');
    root.setAttribute('role', 'region');
    slides.forEach(function (slide, index) {
      slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
    });
    copies.forEach(function (copy, index) {
      copy.setAttribute('aria-hidden', index === current ? 'false' : 'true');
    });
    dots.forEach(function (dot, index) {
      if (index === current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    window.addEventListener('resize', scheduleMobileLayout);
    window.addEventListener('load', scheduleMobileLayout);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleMobileLayout);

    refreshReveal(copies[current]);
    scheduleMobileLayout();
    play();
  }

  function init() {
    document.querySelectorAll('[data-nw-diaporama]').forEach(initDiaporama);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-nw-diaporama]');
    if (root) initDiaporama(root);
  });
})();
